module.exports = __webpack_public_path__ + "img/person-locked.f7b4b040.svg";